import { render, staticRenderFns } from "./DashboardListBlock.vue?vue&type=template&id=15ccb5cd&"
import script from "./DashboardListBlock.vue?vue&type=script&lang=js&"
export * from "./DashboardListBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports